import { Axios } from "@workspace/common";

import {
  BASE_CANDIDATE_EDUCATION_DETAILS,
  BASE_CANDIDATE_WORK_EXPERIENCE,
  BASE_CANDIDATE_CERTIFICATE,
  BASE_CANDIDATE_SELF_INTRO_VIDEO,
  BASE_CANDIDATE_LANGUAGES,
  BASE_CANDIDATE_PUBLIC,
} from "./url_helper";

import {
  CANDIDATE_WORK_EXPERIENCE_URL,
  CANDIDATE_EDUCATION_DETAILS_URL,
  CANDIDATE_CERTIFICATE_URL,
  CANDIDATE_URL,
  CANDIDATE_LANGUAGES_URL,
} from "@workspace/common/src/config";

const { APIClient } = Axios;
const api = new APIClient();

// Candidate Education
export const getEducationDetails = (entity, id) =>
  api.get(
    `${CANDIDATE_EDUCATION_DETAILS_URL}${BASE_CANDIDATE_EDUCATION_DETAILS}/entity/${entity}/${id}`
  );

// Candidate Work Experience
export const getWorkExperienceDetails = (entity, id) =>
  api.get(
    `${CANDIDATE_WORK_EXPERIENCE_URL}${BASE_CANDIDATE_WORK_EXPERIENCE}/entity/${entity}/${id}`
  );

// Candidate Certificates
export const getCertificates = (entity, id) =>
  api.get(
    `${CANDIDATE_CERTIFICATE_URL}${BASE_CANDIDATE_CERTIFICATE}/entity/${entity}/${id}`
  );

// Delete Work Experience
export const deleteWorkExperience = (id) =>
  api.delete(
    `${CANDIDATE_WORK_EXPERIENCE_URL}${BASE_CANDIDATE_WORK_EXPERIENCE}/${id}`
  );

// Delete Candidate Education
export const deleteEducationDetails = (id) =>
  api.delete(
    `${CANDIDATE_EDUCATION_DETAILS_URL}${BASE_CANDIDATE_EDUCATION_DETAILS}/${id}`
  );

// Delete Candidate Certificates
export const deleteCertificates = (id) =>
  api.delete(`${CANDIDATE_CERTIFICATE_URL}${BASE_CANDIDATE_CERTIFICATE}/${id}`);

// Create Candidate Media
export const createCandidateMedia = (data, config) =>
  api.create(
    `${CANDIDATE_URL}${BASE_CANDIDATE_SELF_INTRO_VIDEO}/candidate-media/add`,
    data,
    config
  );

// Get Candidate Media
export const getCandidateMedia = (id) =>
  api.get(
    `${CANDIDATE_URL}${BASE_CANDIDATE_SELF_INTRO_VIDEO}/candidate-media/get/${id}`
  );

// Delete Candidate Media
export const deleteCandidateMedia = (id) =>
  api.delete(
    `${CANDIDATE_URL}${BASE_CANDIDATE_SELF_INTRO_VIDEO}/candidate-media/delete/${id}`
  );

// Update Candidate Media
export const updateCandidateMedia = (id, data, config) =>
  api.put(
    `${CANDIDATE_URL}${BASE_CANDIDATE_SELF_INTRO_VIDEO}/candidate-media/update/${id}`,
    data,
    config
  );

// Create Work Experience Project
export const createProjectMedia = (data, config) =>
  api.create(
    `${CANDIDATE_WORK_EXPERIENCE_URL}${BASE_CANDIDATE_WORK_EXPERIENCE}/project/add`,
    data,
    config
  );

// Fetch Work Experience Project
export const fetchProjectMedia = (id) =>
  api.get(
    `${CANDIDATE_WORK_EXPERIENCE_URL}${BASE_CANDIDATE_WORK_EXPERIENCE}/project/get/${id}`
  );

// Fetch Work Experience Project by Work Experience ID
export const fetchProjectMediaByWorkExperienceId = (id) =>
  api.get(
    `${CANDIDATE_WORK_EXPERIENCE_URL}${BASE_CANDIDATE_WORK_EXPERIENCE}/project/public/get/work-experience/${id}`
  );

// Fetch Work Experience Project List
export const fetchProjectMediaByListOfWorkExperienceId = (id) =>
  api.get(
    `${CANDIDATE_WORK_EXPERIENCE_URL}${BASE_CANDIDATE_WORK_EXPERIENCE}/project/get/work-experience/list?workExperienceIds=${id}`
  );

// Delete Work Experience Project
export const deleteProjectMedia = (id) =>
  api.delete(
    `${CANDIDATE_WORK_EXPERIENCE_URL}${BASE_CANDIDATE_WORK_EXPERIENCE}/project/delete/${id}`
  );

// Update Work Experience Project by Id
export const updateProjectMedia = (id, data, config) =>
  api.put(
    `${CANDIDATE_WORK_EXPERIENCE_URL}${BASE_CANDIDATE_WORK_EXPERIENCE}/project/update/${id}`,
    data,
    config
  );

// Fetch Public Work Experience
export const getPublicCandidateWorkExperience = (id) =>
  api.get(
    `${CANDIDATE_WORK_EXPERIENCE_URL}${BASE_CANDIDATE_WORK_EXPERIENCE}/public/entity/candidate_work_experience/${id}`
  );

// Fetch Public Languages
export const getPublicCandidateLanguages = (id) =>
  api.get(
    `${CANDIDATE_LANGUAGES_URL}${BASE_CANDIDATE_LANGUAGES}/public/entity/candidate_languages/${id}`
  );

// Fetch Public Education Details
export const getPublicCandidateEducationDetails = (id) =>
  api.get(
    `${CANDIDATE_EDUCATION_DETAILS_URL}${BASE_CANDIDATE_EDUCATION_DETAILS}/public/entity/candidate_education_details/${id}`
  );

// Fetch Public Certificates
export const getPublicCandidateCertificates = (id) =>
  api.get(
    `${CANDIDATE_CERTIFICATE_URL}${BASE_CANDIDATE_CERTIFICATE}/public/entity/candidate_certifications/${id}`
  );

// Fetch Public Candidate by Email
export const getPublicCandidateByEmail = (email) =>
  api.get(`${CANDIDATE_URL}${BASE_CANDIDATE_PUBLIC}/email/${email}`);
